import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {
  notificationForm: any;
  type: any = [
    { typeName: 'Text', value: 'text' },
    { typeName: 'Media', value: 'media' },
  ];
  imageArr: any = [];
  imageFileArr: any = [];
  videoArr: any = [];
  videoFileArr: any = [];
  deleteImg: any = [];
  deleteVideo: any = [];
  fileInput: any;
  userSuggestions: any = [];
  stores: any = [];
  timeout: any = null;
  initialTypeValue: any;
  showStoreInput = true;

  constructor(
    private spinner: NgxSpinnerService,
    private service: ApiService,
    private toastr: ToastrService
  ) {}
  ngOnInit() {
    this.notificationForm = new FormGroup({
      title: new FormControl('', Validators.required),
      type: new FormControl('text'),
      userId: new FormControl(),
      storeId: new FormControl(''),
      media: new FormControl([]),
      description: new FormControl(''),
    });
    this.initialTypeValue = this.notificationForm.get('type').value;
    this.getUsers();
    this.getStore();
  }
  onSelectAll() {
    const selected = this.userSuggestions.map((item: any) => item.id);
    this.notificationForm.get('userId').patchValue(selected);
  }
  onClearAll() {
    this.notificationForm.get('userId').patchValue([]);
  }
  toggleInput(checked: boolean) {
    this.showStoreInput = checked;
  }
  onTypeChange() {
    const selectedType = this.notificationForm.get('type').value;
    if (selectedType === 'media') {
      this.notificationForm.get('description').setValue();
    } else if (selectedType === 'description') {
    }
  }
  getUsers() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.getUserListForNotification).subscribe(
      (res: any) => {
        // console.log(res.response);
        this.userSuggestions = res.response.data;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }
  onKeySearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getUsers();
    }, 1000);
  }
  selectUser(selectedUser: any) {
    let currentUsers = this.notificationForm.get('userId').value;

    if (!currentUsers.includes(selectedUser.id)) {
      currentUsers.push(selectedUser.id);
      this.notificationForm.get('userId').setValue(currentUsers);
    }
  }

  getStore() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.getStoreListForNotification).subscribe(
      (res: any) => {
        // console.log(res.response);
        this.stores = res.response.data;
        // console.log(this.stores, 'dsafsdfsd');
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }
  sendNotification() {
    if (this.notificationForm.valid) {
      this.spinner.show();
      let formdata = new FormData();
      formdata.append('type', this.notificationForm.get('type').value);
      formdata.append('title', this.notificationForm.get('title').value);
      if (this.imageFileArr.length) {
        for (var i = 0; i < this.imageFileArr.length; i++) {
          formdata.append('media', this.imageFileArr[i]);
        }
      }
      if (this.videoFileArr.length) {
        for (var i = 0; i < this.videoFileArr.length; i++) {
          formdata.append('videos', this.videoFileArr[i]);
        }
      }

      if (this.notificationForm.value.type !== 'media') {
        formdata.append('description', this.notificationForm.value.description);
      }
      // formdata.append('description', this.notificationForm.get('description').value);
      if (this.notificationForm.value.userId) {
        this.notificationForm.value.userId.map((m: any) => {
          formdata.append('userId', m);
        });
      }
      if (this.notificationForm.value.storeId) {
        formdata.append('storeId', this.notificationForm.get('storeId').value);
      }

      this.service
        .postRequest(`${ApiUrl.sendNotification}`, formdata)
        .subscribe(
          (res: any) => {
            // console.log(res, 'send');
            this.toastr.success(res.response.message);
            this.spinner.hide();
            this.resetForm();
          },
          (err) => {
            this.spinner.hide();
            this.toastr.error(err.error.response.message);
          }
        );
    } else {
    }
  }
  resetForm() {
    this.notificationForm.reset({
      type: this.initialTypeValue,
      title: '',
      description: '',
      userId: [],
      storeId: '',
    });
    this.imageFileArr = [];
    this.videoFileArr = [];
  }
  updateFile(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      // console.log(file.type, 'type');
      if (file.type.startsWith('image')) {
        // console.log(file.type.startsWith('image'), 'image');
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageFileArr.push(file);
          this.imageArr.push(e.target.result);
          // console.log('Image loaded:', this.imageArr);
        };
        reader.readAsDataURL(file);
      } else if (file.type.startsWith('video')) {
        // console.log(file.type.startsWith('video'), 'video');
        // if (!this.videoArr[i]) {
        this.videoFileArr.push(file);
        this.videoArr.push(URL.createObjectURL(file));
        // console.log('Video loaded:', this.videoArr);
        // }
      } else {
        // console.error('Unsupported file type');
      }
    }
  }

  // updateImage(event: any, i: number) {
  //   const files = event.target.files;
  //   if (files && files.length > 0) {
  //     const file = files[0];
  //     const reader = new FileReader();
  //     reader.onload = (e: any) => {
  //       this.imageFileArr[i] = file;
  //       this.imageArr[i] = e.target.result;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

  removeImage(ind: number) {
    const fullImagePath = this.imageArr[ind];
    const relativeImagePath = fullImagePath.replace(/^.*\/static\//, 'static/');

    this.imageArr.splice(ind, 1);
    this.imageFileArr.splice(ind, 1);
    this.deleteImg.push(relativeImagePath);
  }

  removeVideo(ind: number) {
    const videoURL = this.videoArr[ind];
    URL.revokeObjectURL(videoURL);
    this.videoArr.splice(ind, 1);
    this.videoFileArr.splice(ind, 1);

    this.deleteVideo.push(URL.revokeObjectURL(videoURL));
  }
}
